import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";

import { ComponentType } from "@angular/cdk/overlay";
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { DialogIPPrefixesAddComponent } from "../../../../components/dialogs/dialog-ip-prefixes-add/dialog-ip-prefixes-add";
import { DialogIPPrefixesRequestComponent } from "../../../../components/dialogs/dialog-ip-prefixes-request/dialog-ip-prefixes-request";

@Component({
  selector: "request-add-prefix",
  templateUrl: "request-add-prefix.html",
  styleUrl: "../../ip-prefixes.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, NgClickOutsideDirective, TranslatePipe],
})
export class RequestAddPrefix {
  private dialog = inject(MatDialog);

  protected overflowMenuIPActive = signal(false);

  protected toggleOverflowMenu() {
    this.overflowMenuIPActive.update((v) => !v);
  }

  private openPrefixDialog(event: Event, component: ComponentType<unknown>) {
    event.stopPropagation();
    event.preventDefault();
    this.dialog.open(component, { disableClose: true });
  }

  protected openRequestPrefixDialog = (event: Event) => this.openPrefixDialog(event, DialogIPPrefixesRequestComponent);
  protected openAddPrefixDialog = (event: Event) => this.openPrefixDialog(event, DialogIPPrefixesAddComponent);
}
